export default __webpack_public_path__ + "static/media/blog_2_3.3482313a.jpg";